import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=2c794f48&"
import script from "./ExchangeList.vue?vue&type=script&lang=js&"
export * from "./ExchangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports